// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5q-1";
export var standaloneTable = "_5q-0";